<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/xNcjPk/tc-custom/9781399084338.jpg?1736422839486" alt="This image is the cover for the book Nazi Spies & Collaborators in Britain, 1939–1945"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Nazi Spies & Collaborators in Britain, 1939–1945
      </h1>
      <p class="bookDescription body article font2">
        <p>"...reveals the climate of fear along with the identities and case studies of suspected collaborators in key invasion areas." —ARGunners.com<br/><br/>The true extent of Nazi secret agent activity in Britain during the Second World War has received little attention. In large part this is due to the highly classified nature of the subject. This fascinating book uses recently released documents to explore how German agents penetrated our borders and explains methods of agent recruitment.  Some spies were arrested and handed over the MI5 for interrogation. Several were turned and became ‘double-cross’ agents, while others were tried and executed or incarcerated in Camp 020 and other facilities. There were also those who came and left undetected and were only revealed after Nazi records were seized.  The story, however, does not end there. While British authorities urged the public to beware of spies and posters warned ‘careless talk costs lives,’ the actual existence of Nazi collaborators in Britain was played down. Author Neil R Storey’s discovery of MI5’s and Regional Security Panels’ ‘Black Lists’ of those considered to be ‘likely to assist the enemy’ in the event of invasion reveals the climate of fear along with the identities and case studies of suspected Nazi collaborators in key invasion areas.  This book is a gripping exposé of the very real threat posed by Nazi undercover operatives and collaborators in Britain during the Second World War.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Neil R. Storey
      </h2>
      
      <p class="authorDescription body article">NEIL R STOREY is an award-winning historian and author who specialises in the impact of war on British society in the first half of the 20th Century. A graduate of the University of East Anglia, he lectures across the UK and has assembled a fine collection of original First and Second World War images to illustrate his works. Neil has published over forty books, has written for national magazines and journals and appears on television documentaries and factual programmes as a guest historian including Who Do You Think You Are? and The Buildings That Fought Hitler.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword Military
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?61f1c82c